import { isEmpty } from '../is'

const _respErrType = '_symbol_resp_err_'
const _transfErrType = '_symbol_transf_err_'
const _notifyErrType = '_symbol_notify_err_'
export class ResponseError extends Error {
  _type_ = _respErrType

  static isResponseError(err) {
    return !isEmpty(err) && err._type_ === _respErrType
  }

  constructor(code, message) {
    super(message)
    this.code = code
    this.message = message
  }

  toString() {
    return this.message
  }
}

export class TransformError extends Error {
  _type_ = _transfErrType

  static isTransformError(err) {
    return !isEmpty(err) && err._type_ === _transfErrType
  }

  constructor(code, message) {
    super(message)
    this.code = code
    this.message = message
  }

  toString() {
    return this.message
  }
}

export class NotifyError extends Error {
  _type_ = _notifyErrType
  static isNotifyError(err) {
    return !isEmpty(err) && err._type_ === _notifyErrType
  }

  constructor(notifyType, message) {
    super(message)
    this.notifyType = notifyType
    this.message = message
  }

  toString() {
    return this.message
  }
}

export function getErrMsg(code) {
  if (code < 500) {
    return '请求异常'
  }
  return '服务异常'
}
